import { Component } from '@angular/core';
import {
  IonicPage, NavController, NavParams,
  AlertController, Platform, ModalController
} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { UsuariosProvider } from '../../providers/usuarios/usuarios'
import { CargosProvider } from '../../providers/cargos/cargos'
import { usuarios } from '../../models/usuarios'
import { UsuariosEditarPage } from '../usuarios/usuarios-editar/usuarios-editar'
import { ClientesProvider } from '../../providers/clientes/clientes'
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO, NUBE_AWS } from "../../config/url.servicio"
import { UtilsProvider } from '../../providers/utils/utils'

@IonicPage()
@Component({
  selector: 'page-usuarios',
  templateUrl: 'usuarios.html',
  providers: [ AuthService ]
})
export class UsuariosPage {

  clave:string
  desconect:string
	codigoUsuario:string
	nombreUsuario:string
	cargosId:string
	administrador:number
	correoElectronico:string
	intentosClaves:string
	ultimoCambioClave:string
	diasCambioClave:number
	cambiaClaveProximoInicioSesion:number
	estado:number
  usuarios = []
  cargos = []
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  usuarioValido:string=""
  versionAWS = NUBE_AWS
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers: AlertController,
    public platforms: Platform,
    public modalControllers: ModalController,
    public servicio: UsuariosProvider,
    public servicioCargos : CargosProvider,
    public servicioClientes:ClientesProvider,
    public utils:UtilsProvider,
    public servicioCompania:CompaniasProvider,
    public auth: AuthService,
    public storages:Storage
               ) {
                   this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
                   .then((val)=>{
                     if(val){
                       this.nombreCompaniaHeader = val['nombreCompania']
                       this.nombreCargoHeader = val['nombreCargo']
                     }
                   })
    this.cargarServicioCargos()
    this.cargarServicio()
  }

  ionViewDidLoad() {
    this.cargarServicio()
    this.cargarServicioCargos()
  }

  cargarServicioCargos() {
    this.storages.get('companiasId').then((val) => {
    this.servicioCargos.buscarCargosPorEmpresa(val)
    .subscribe((data) => {
      if(NUBE_AWS){
        this.cargos =  JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data[0]
      } else {
        this.cargos = data
      }
    }, error => {
      console.log(error)
    })
  })
  }

  cargarServicio() {
    this.storages.get('companiasId').then((val) => {
      this.servicio.buscarUsuarioPorEmpresa(val)
      .subscribe((data) => {
        if(NUBE_AWS){
          this.usuarios =  JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data[0]
        } else {
          this.usuarios = data
        }
      }, error => {
        console.log(error)
      })
    })

  }

  guardar() {

    // let valores: any = {
    //   clave: this.clave,
    //   codigoUsuario: this.codigoUsuario,
    //   nombreUsuario: this.nombreUsuario,
    //   cargosId: this.cargos['cargosId'] ,
    //   administrador: this.administrador,
    //   correoElectronico: this.correoElectronico,
    //   intentosClaves: this.intentosClaves,
    //   ultimoCambioClave: this.fechaActual(),
    //   diasCambioClave: this.diasCambioClave,
    //   desconect: this.desconect,
    //   cambiaClaveProximoInicioSesion: this.cambiaClaveProximoInicioSesion,
    //   estado: this.estado
    // }
    let valores: any = {
      clave: this.desconect,
      codigoUsuario: this.codigoUsuario,
      nombreUsuario: this.nombreUsuario,
      cargosId: this.cargos['cargosId'] ,
      administrador: this.administrador,
      correoElectronico: "",
      intentosClaves: 99,
      ultimoCambioClave: this.fechaActual(),
      diasCambioClave: 99,
      desconect: this.desconect,
      cambiaClaveProximoInicioSesion: "0",
      estado: "1"
    }
    this.storages.get('companiasId').then((val) => {
      valores['companiasId'] = val
    this.servicio.guardar(valores)
      .subscribe(
      res => {
        // this.usuarios.push(res[0])
        this.utils.mensajeMuestro('Usuarios','Usuario creado con éxito!','success')
        this.usuarios = []
        this.cargarServicio()
      },
      err =>
      {
        console.log(err)
      }
      )
    })

    this.clave = ""
    this.codigoUsuario = ""
    this.nombreUsuario = ""
    this.cargosId = "0"
    this.administrador = 0
    this.correoElectronico = ""
    this.intentosClaves = ""
    this.ultimoCambioClave = ""
    this.diasCambioClave = 0
    this.desconect = ""
    this.cambiaClaveProximoInicioSesion = 0
    this.estado = 1

  }

  editar(usuariosData: any) {

    let modal = this.modalControllers.create(UsuariosEditarPage, { usuariosData:usuariosData })
    modal.present();

    modal.onDidDismiss(data => {

      if(data){
        this.editarRegistrosUsuarios(usuariosData, data);
      }

    })

  }

editarRegistrosUsuarios(originalTodo: any, modificadoTodo: any){

    const index = this.usuarios.indexOf(originalTodo);

        this.usuarios = [
          ...this.usuarios.slice(0,index),
          modificadoTodo,
          ...this.usuarios.slice(index + 1)
        ]

        modificadoTodo.name = "registroUsuario"
        modificadoTodo.ultimoCambioClave = this.fechaActual()
        modificadoTodo.queHago = "A"
        modificadoTodo.nombreTabla = "usuarios"
        if(modificadoTodo.clave !== modificadoTodo.desconect ) {
          this.utils.mensajeMuestro('Usuarios','la nueva clave no es la misma verifique!','advertencia')
          return
        }
        this.servicio.buscarUsuarioDesconect(modificadoTodo.usuariosId)
        .subscribe(
         (res: any) => {
          this.storages.get('companiasId').then((val) => {
            modificadoTodo['companiasId'] = val
            let claveactual =  JSON.parse(res['_body']).data[0] === undefined ? '' : JSON.parse(res['_body']).data[0][0].claveactual
            modificadoTodo['claveactual'] = claveactual
         this.servicio.actualizar(modificadoTodo)
         .subscribe(
          res => {
            this.utils.mensajeMuestro('Usuarios','Usuario Gestionado','success')
            this.usuarios = []
            this.cargarServicio()
          },
          err => {
            console.log(err)}
        )
      })
         },
         err => {
           console.log(err)}
       )
}

fechaActual() {
  var hoy = new Date();
  var dd = JSON.stringify(hoy.getDate());
  let dia = Number(dd)
  var mm = JSON.stringify(hoy.getMonth()+1); //hoy es 0!
  let mes = Number(mm)
  var yyyy = hoy.getFullYear();

  if(dia<10) {
      dd='0'+dd
  }

  if(mes<10) {
      mm='0'+mm
  }

  return yyyy+'-'+mm+'-'+dd;
}

cerrarSession(){
  this.auth.logout()
  this.navCtrl.setRoot('LoginPage');
}

validarInput(cantidadafn:any,i:any){


setTimeout(() => {

  let campoValidar = ""
  if(cantidadafn['_value']!==""){
    campoValidar = cantidadafn['_value']
  }else{
      cantidadafn['_value'] = ""
      return
  }
   if(campoValidar===""){
       return false
   }
   let modo = MODO_DESCONECTADO
      if(!modo){

          this.servicioCompania.buscarCodigoUsuarioValido(campoValidar)
          .debounceTime(3000)
          .subscribe((data)=>{
            if(NUBE_AWS){
              data = JSON.parse(data._body).data[0]
            }
            console.log('paso',data)
            if(data[0].validar !== 0){
              this.codigoUsuario = ""
              this.usuarioValido = 'El código no es valido'
            }else{
              this.usuarioValido = ''
            }
          },(error)=>{
          })}
          else{

          }
  }, 3000);
}




}



// WEBPACK FOOTER //
// ./src/pages/usuarios/usuarios.ts